import { clsx } from 'clsx'
import { ComponentRef, forwardRef } from 'react'

import { Button, ButtonSpinner, ButtonText, type ButtonProps } from '@/components'

export interface BigRedButtonProps extends ButtonProps {
  children?: string
  isLoading?: boolean
  withUppercase?: boolean
}

export type BigRedButtonRef = ComponentRef<typeof Button>

export const BigRedButton = forwardRef<BigRedButtonRef, BigRedButtonProps>(
  (
    {
      accessibilityLabel,
      children = 'Continue',
      className,
      isDisabled,
      isLoading,
      size = 'lg',
      withUppercase = true,
      ...props
    },
    ref
  ) => (
    <Button
      accessibilityLabel={accessibilityLabel ?? children}
      accessibilityState={{
        busy: isLoading,
        disabled: isDisabled
      }}
      className={clsx(
        'h-fit w-full rounded-lg bg-brand-orange-500 px-3 py-2 data-[hover=true]:bg-brand-orange-600 data-[active=true]:bg-brand-orange-600 data-[disabled=true]:bg-brand-grey-400',
        className
      )}
      isDisabled={isDisabled}
      ref={ref}
      size={size}
      {...props}
    >
      {isLoading ? (
        <ButtonSpinner
          className='color-white'
          size='small'
        />
      ) : null}
      <ButtonText
        className={clsx(
          'text-center font-poppinsSemiBold text-white data-[hover=true]:text-white data-[active=true]:text-white',
          withUppercase && 'uppercase'
        )}
      >
        {children}
      </ButtonText>
    </Button>
  )
)

BigRedButton.displayName = 'BigRedButton'
